"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.updateBillingInfo = updateBillingInfo;
exports.removeUser = removeUser;
exports.changeRole = changeRole;
exports.approveUser = approveUser;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = "maaporssi/company/LOAD";
var LOAD_SUCCESS = "maaporssi/company/LOAD_SUCCESS";
var LOAD_FAIL = "maaporssi/company/LOAD_FAIL";

var UPDATE_USER = "maaporssi/company/UPDATE_USER";
var UPDATE_USER_SUCCESS = "maaporssi/company/UPDATE_USER_SUCCESS";
var UPDATE_USER_FAIL = "maaporssi/company/UPDATE_USER_FAIL";

var UPDATE_COMPANY = "maaporssi/company/UPDATE_COMPANY";
var UPDATE_COMPANY_SUCCESS = "maaporssi/company/UPDATE_COMPANY_SUCCESS";
var UPDATE_COMPANY_FAIL = "maaporssi/company/UPDATE_COMPANY_FAIL";

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        error: action.error.error
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        company: action.result
      });

    case UPDATE_USER:
      return (0, _extends3.default)({}, state, {
        userChangeLoading: true,
        userChangeError: null,
        userChangeSuccess: false
      });
    case UPDATE_USER_FAIL:
      return (0, _extends3.default)({}, state, {
        userChangeLoading: false,
        userChangeError: action.error.error,
        userChangeSuccess: false
      });
    case UPDATE_USER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userChangeLoading: false,
        userChangeSuccess: true,
        userChangeError: null
      });
    case UPDATE_COMPANY:
      return (0, _extends3.default)({}, state, {
        companyUpdateLoading: true,
        companyUpdateError: null,
        companyUpdateSuccess: false
      });
    case UPDATE_COMPANY_FAIL:
      return (0, _extends3.default)({}, state, {
        companyUpdateLoading: false,
        companyUpdateError: true,
        companyUpdateSuccess: false
      });
    case UPDATE_COMPANY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        companyUpdateLoading: false,
        companyUpdateSuccess: true,
        companyUpdateError: null,
        company: action.result
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState && globalState.company && globalState.company.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get("/company");
    }
  };
}

function updateBillingInfo(companyId, formData) {
  return {
    types: [UPDATE_COMPANY, UPDATE_COMPANY_SUCCESS, UPDATE_COMPANY_FAIL],
    promise: function promise(client) {
      return client.put("/companies/" + companyId, {
        data: formData
      });
    }
  };
}

function removeUser(companyId, userId) {
  return {
    types: [UPDATE_USER, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL],
    promise: function promise(client) {
      return client.del("/companies/" + companyId + "/users/" + userId);
    }
  };
}

function changeRole(companyId, userId, role) {
  return createRoleAction(companyId, userId, role);
}

function approveUser(companyId, userId) {
  return createRoleAction(companyId, userId, "user");
}

function createRoleAction(companyId, userId, role) {
  return {
    types: [UPDATE_USER, UPDATE_USER_SUCCESS, UPDATE_USER_FAIL],
    promise: function promise(client) {
      return client.put("/companies/" + companyId + "/users/" + userId, {
        data: { role: role }
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/company.js
 ** module id = 207
 ** module chunks = 0
 **/